import React from 'react';
import classes from './ProjectFilters.module.css';

const ProjectFilters = ({
  searchValue,
  setSearchValue,
  sortBy,
  setSortBy,
  sortDirection,
  setSortDirection
}) => {
  return (
    <div className={classes.filters}>
      <input
        type="text"
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        placeholder="Search projects"
        className={classes.searchInput}
      />
      <select
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value)}
        className={classes.select}
      >
        <option value="name">Name</option>
        <option value="updatedAt">Last modified</option>
        <option value="createdAt">Date Created</option>
      </select>
      <select
        value={sortDirection}
        onChange={(e) => setSortDirection(e.target.value)}
        className={classes.select}
      >
        <option value="asc">Ascending</option>
        <option value="desc">Descending</option>
      </select>
    </div>
  );
};

export default ProjectFilters;